import { render } from "./ManageLanguages.vue?vue&type=template&id=5cf62ecc&scoped=true"
import script from "./ManageLanguages.vue?vue&type=script&lang=ts"
export * from "./ManageLanguages.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5cf62ecc"

export default script